import { render } from "./AddProductPhotoView.vue?vue&type=template&id=ce1f0a40"
import script from "./AddProductPhotoView.vue?vue&type=script&lang=js"
export * from "./AddProductPhotoView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__